import React from 'react';
import './partners.scss';
import { translate } from "react-translate";
import { Row, Col } from 'react-bootstrap';

import partner1 from '../../../images/partner1.png';
import partner2 from '../../../images/partner2.png';
import partner3 from '../../../images/partner3.png';
import partner4 from '../../../images/partner4.png';

class Partners extends React.Component {

  render() {
    return(
      <div className="component partners">
        <div className="content">
          <h4 className="block_title capsFont">{ this.props.t('partners') }</h4>

          <div className="list">
            <Row>
              <Col lg={3}>
                <div className="partner_image">
                  <img src={partner1} alt="partner" />
                </div>
                <p className="capsFont partner_name">{ this.props.t('sp3') }</p>
              </Col>
              <Col lg={3}>
                <div className="partner_image">
                  <img src={partner3} alt="partner" />
                </div>
                <p className="capsFont partner_name">{ this.props.t('sp2') }</p>
              </Col>
              <Col lg={3}>
                <div className="partner_image">
                  <img src={partner2} alt="partner" />
                </div>
                <p className="capsFont partner_name">{ this.props.t('sp1') }</p>
              </Col>
              <Col lg={3}>
                <div className="partner_image">
                  <img src={partner4} alt="partner" />
                </div>
                <p className="capsFont partner_name">{ this.props.t('sp4') }</p>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }

}

export default translate('Partners')(Partners);